import { Container, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CoinHeader from "../CoinHeader/CoinHeader";
import CoinChart from "../CoinRowDetails/CoinChart";
import axios from "../../axios";
import { ListGroup } from "react-bootstrap";
import "./CoinPage.css";
import ExchangeSingleCoin from "../ExchangeSingleCoinTable/ExchangeSingleCoin";

function CoinPage() {
  const { coinid } = useParams();
  const [coinData, setCoinData] = useState({});
  const [selectedInterval, setSelectedInterval] = useState("1D");

  useEffect(() => {
    setInterval(() => {
      axios
        .get(`/assets/${coinid}`)
        .then((res) => {
          setCoinData(res.data.data);
        })
        .catch((err) => console.log(err));
    }, 3000);
  }, [coinid]);

  const handleIntervalClick = (val) => {
    setSelectedInterval(val);
  };

  return (
    <Container fixed>
      <Grid container>
        <Grid item xs={12}>
          <CoinHeader
            loading={Object.keys(coinData).length !== 0 ? false : true}
            coinData={coinData}
          />
        </Grid>
        <Grid item xs={12}>
          <CoinChart coinId={coinid} interval={selectedInterval} />
        </Grid>
        <Grid item xs={12}>
          <ListGroup horizontal className="timelist">
            {["1D", "1W", "1M", "3M", "6M", "1Y", "ALL"].map((val) => (
              <ListGroup.Item
                className={`timelist-item ${
                  selectedInterval === val ? "timelist-item-selected" : ""
                }`}
                onClick={() => handleIntervalClick(val)}
              >
                {val}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Grid>
        <Grid item xs={12}>
          <ExchangeSingleCoin symbol={coinid} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default CoinPage;
